export const visit = (vm, at) => {
at({ "en": { "conversations-thread-view": { "plugins-at-mentions": { "mentionEmptyState": { "text": "No results" } } } } });
};